export const dateFormats = [
  // { label: 'Separated', value: 'delimited' },
  {
    label: 'Month day year',
    options: [
      { label: 'MMDDYYYY', value: 'MMDDYYYY' },
      { label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
      { label: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
      { label: 'MM.DD.YYYY', value: 'MM.DD.YYYY' },
      { label: 'MM_DD_YYYY', value: 'MM_DD_YYYY' },
      { label: 'MM DD YYYY', value: 'MM DD YYYY' }
    ]
  },
  {
    label: 'Month day 2 digit year',
    options: [
      { label: 'MMDDYY', value: 'MMDDYY' },
      { label: 'MM/DD/YY', value: 'MM/DD/YY' },
      { label: 'MM-DD-YY', value: 'MM-DD-YY' },
      { label: 'MM.DD.YY', value: 'MM.DD.YY' },
      { label: 'MM_DD_YY', value: 'MM_DD_YY' },
      { label: 'MM DD YY', value: 'MM DD YY' }
    ]
  },
  {
    label: 'Day month year',
    options: [
      { label: 'DDMMYYYY', value: 'DDMMYYYY' },
      { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
      { label: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
      { label: 'DD.MM.YYYY', value: 'DD.MM.YYYY' },
      { label: 'DD_MM_YYYY', value: 'DD_MM_YYYY' },
      { label: 'DD MM YYYY', value: 'DD MM YYYY' }
    ]
  },
  {
    label: 'Year month day',
    options: [
      { label: 'YYYYMMDD', value: 'YYYYMMDD' },
      { label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
      { label: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
      { label: 'YYYY.MM.DD', value: 'YYYY.MM.DD' },
      { label: 'YYYY_MM_DD', value: 'YYYY_MM_DD' },
      { label: 'YYYY MM DD', value: 'YYYY MM DD' }
    ]
  }
];

export const addressFormats = [
  {
    label: 'Full address',
    options: [
      {
        label: 'Address line 1, address line 2, city, state, zip',
        value:
          '^(?<address_ln_1>[^,]*),\\s*(?<address_ln_2>[^,]*),\\s*(?<city>[^,]*),\\s*(?<state>[A-Za-z]{2})?,\\s*(?<zip>\\d{5})$'
      },
      {
        label: 'Address line 1, city, state, zip',
        value:
          '^(?<address_ln_1>[^,]+),\\s*(?<city>[^,]+),\\s*(?<state>[A-Z]{2}),\\s*(?<zip>\\d{5})$'
      },
      {
        label: 'Address line 1, address line 2, city, state',
        value:
          '^(?<address_ln_1>[^,]+),\\s*(?<address_ln_2>[^,]+),\\s*(?<city>[^,]+),\\s*(?<state>[A-Z]{2})$'
      },
      {
        label: 'Address line 1, address line 2, city',
        value: '^(?<address_ln_1>[^,]+),\\s*(?<address_ln_2>[^,]+),\\s*(?<city>[^,]+)$'
      },
      {
        label: 'Address line 1, city',
        value: '^(?<address_ln_1>[^,]+),\\s*(?<city>[^,]+)$'
      }
    ]
  },
  {
    label: 'City and state only',
    options: [
      {
        label: 'City, state, zip',
        value: '^(?<city>[^,]+),\\s*(?<state>[A-Za-z]{2}),\\s*(?<zip>\\d{5})$'
      },
      {
        label: 'City, state',
        value: '^(?<city>[^,]+),\\s*(?<state>[A-Za-z]{2})$'
      }
    ]
  },
  {
    label: 'State and zip only',
    options: [
      {
        label: 'State, zip',
        value: '^(?<state>[A-Za-z]{2}),\\s*(?<zip>\\d{5})$'
      }
    ]
  }
];

export const nameFormatOptions = [
  { label: 'First last', value: 'first_last' },
  { label: 'Last first', value: 'last_first' },
  { label: '% Last First %', value: '%last_first%' },
  { label: '% First Last %', value: '%first_last%' },
  { label: '%,First,Last,%', value: '%,first,_last,%' },
  { label: '%,Last,First,%', value: '%,last,_first,%' }
];

export const currencyFormats = [
  { label: '10.00$ (in dollars)', value: 'dollars' },
  { label: '1000cents (in cents)', value: 'cents' }
];
